import { __assign } from "tslib";
import EventEmitter from 'mitt';
import { merge, startsWith } from 'lodash';
import createHttpClient from './http';
import { Environments, PRODUCTION_API_URL, SANDBOX_API_URL } from './constants';
var Client = (function () {
    function Client(options) {
        var _this = this;
        var apiHost = options.apiHost, env = options.env, onAccessTokenReceived = options.onAccessTokenReceived, axiosOptions = options.axiosOptions;
        var emitter = new EventEmitter();
        this.env = env || Environments.DEVELOPMENT;
        this.onAccessTokenReceived = onAccessTokenReceived;
        this.on = emitter.on;
        this.off = emitter.off;
        this.emit = emitter.emit;
        this.http = createHttpClient(__assign(__assign({}, merge({ headers: { 'X-Client': 'heydoctor' } }, axiosOptions)), { baseURL: apiHost && (Environments.DEVELOPMENT || Environments.SANDBOX)
                ? apiHost
                : this.env === Environments.PRODUCTION
                    ? PRODUCTION_API_URL
                    : SANDBOX_API_URL }));
        this.http.interceptors.response.use(function (response) {
            _this.emit('http:success', {
                statusCode: response && response.status,
                data: response && response.data,
                hideSuccessAlert: response && response.config.hideSuccessAlert,
            });
            return response;
        }, function (error) {
            _this.emit('http:error', {
                statusCode: error.response && error.response.status,
                data: error.response && error.response.data,
                hideErrorAlert: error.config.hideErrorAlert,
            });
            return Promise.reject(error);
        });
    }
    Client.prototype.setAccessToken = function (accessToken) {
        var token = accessToken
            ? startsWith(accessToken, 'Bearer')
                ? accessToken
                : "Bearer " + accessToken
            : accessToken;
        this.accessToken = token;
        this.http.defaults.headers.Authorization = token;
        if (this.onAccessTokenReceived) {
            this.onAccessTokenReceived(token);
        }
    };
    Client.prototype.getAccessToken = function () {
        return this.accessToken;
    };
    Client.prototype.setCurrentUser = function (user) {
        this.currentUser = user;
    };
    Client.prototype.getCurrentUser = function () {
        return this.currentUser;
    };
    Client.prototype.logout = function () {
        this.setCurrentUser();
        this.setAccessToken();
    };
    return Client;
}());
export default Client;
//# sourceMappingURL=client.js.map